import { useQuery } from '@tanstack/react-query';
import { fetchRewardMirrorStatus } from '../services/analytics-service';

/**
 * Cheap, tier-agnostic reward-mirror freshness check for surfaces that
 * shouldn't pay for the full tier-gated analytics payload just to render one
 * warning banner (see ShopOwnerDashboard.tsx's operational tab — fix round
 * 1, Finding 3: useAnalyticsSummary there meant a 403+3-retries no-op for
 * every free-tier shop, plus a ~5000-row scan for founding/pro shops, on the
 * tab open during service). The mirror's sync state is global — one cron for
 * the whole platform — so no shopId is needed; `enabled` should reflect
 * whether the caller has an authenticated session at all.
 */
export function useRewardMirrorStatus(enabled: boolean) {
  return useQuery({
    queryKey: ['reward-mirror-status'],
    queryFn: fetchRewardMirrorStatus,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
